import IImageSrcset from './IImageSrcset';
import AspectRatio from '../../base/AspectRatio';

export default interface IImage {
	type?: string;
	aspectRatio?: AspectRatio;
	src?: string;
	width?: number;
	height?: number;
	srcset?: IImageSrcset[];
	alt: string;
	caption?: string;
	class?: string;
}

// Type Guard
export function isImage(object: any | IImage): object is IImage {
	return object && ((object as IImage).src !== undefined || (object as IImage).srcset !== undefined);
}
